// extracted by mini-css-extract-plugin
export default {"Navbar":"NavMenu_Navbar__ltB+f"};